// extracted by mini-css-extract-plugin
export var typingIndicator = "_k1-0";